import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import ProviderWithRouter from './ProviderWithRouter';
const container = document.getElementById('root');
const root = createRoot(container);
import { PrismicProvider } from '@prismicio/react';
import client from './prismic/prismic';

root.render(
  <ProviderWithRouter>
    <BrowserRouter>
      <PrismicProvider client={client}>
        <App />
      </PrismicProvider>
    </BrowserRouter>
  </ProviderWithRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
